'use client';

import React from 'react';
import { NavigationContext } from '@/context/Navigation';

export default function Template({ children }: { children: React.ReactNode }) {
    const navigationContext = React.useContext(NavigationContext);

    React.useEffect(() => {
        navigationContext.hideLoadingScreen();
    }, [navigationContext]);

    return children;
}
